var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 68,
    viewBox: "0 0 41 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98828 9.12109H31.437V27.4702H8.98828V9.12109ZM8.98828 31.3764H18.2595V36.2552H8.98828V31.3764ZM22.1658 31.3764H31.437V36.2552H22.1658V31.3764Z",
    fill: "#969C9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5823 0.335938H4.83489C2.27877 0.335938 0.199219 2.41549 0.199219 4.97162V49.1895C0.199219 51.7456 2.27877 53.8251 4.83489 53.8251H11.6668V45.0401H28.7505V53.8251H35.5824C38.1385 53.8251 40.2181 51.7456 40.2181 49.1895V4.97162C40.218 2.41549 38.1384 0.335938 35.5823 0.335938ZM35.3392 40.1613H5.07799V5.21471H35.3392V40.1613ZM15.5729 62.1238H24.8441V67.0026H15.5729V62.1238Z",
    fill: "#969C9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.575 48.9453H24.8462V58.2167H15.575V48.9453Z",
    fill: "#969C9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step_4.fa41666c6dedf162b5d70f145d728f83.svg";
export { ForwardRef as ReactComponent };